module.exports = __webpack_public_path__ + "static/media/logo.0511c6d3.png";